// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__18hFh","title":"AfterFrontImage_title__255G7"};